import React, { useEffect, useState } from "react";
import Button from "../../Component/Button/Button";
import { faMapMarkerAlt, faStore } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./PastOrders.module.css";
import { errorToast } from "../../Toast/Toast";
import moment from "moment-jalaali";
import Modal from "../Modal/Modal";
import Factor from "../Factor/Factor";
import AddComment from "../AddComment/AddComment";
import { getFactorOrderApi, getPastOrderApi } from "../../Api/ClientServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { separate } from "../../Seprate/Seprate";
import { Link } from "react-router-dom";
import OrderPerviewList from "../OrderPerviewList/OrderPerviewList";
import { Modal as AntdModal, Rate } from "antd";
import TransactionList from "../TransactionList/TransactionList";
const PastOrders = () => {
  const [data, setData] = useState();
  const [purchased, setPurchased] = useState(false);
  const [FactorData, setFactorData] = useState();
  const [AddCommentModal, setAddCommentModal] = useState();
  const [commentOrderId, setCommentOrderId] = useState();
  const [commentSuplierId, setCommentSuplierId] = useState();
  const [modalState, setModalState] = useState(false);
  const [modalState2, setModalState2] = useState(false);
  const [orderDataState, setOrderDataState] = useState([]);
  const [transactionDataState, setTransactionDataState] = useState();
  useEffect(() => {
    getPastOrders();
  }, []);
  const getPastOrders = async () => {
    getPastOrderApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast(res.message);
          setData([]);
        } else {
          setData(calculateOrderTotals(res).orders);
        }
      } else {
        console.error(res);
      }
    });
  };
  const FactorHandler = async (orderID) => {
    setPurchased(true);
    getFactorOrderApi(orderID, 0, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
          setData([]);
        } else {
          setFactorData(res.factor);
        }
      } else {
        console.error(res);
      }
    });
  };
  const closeModalHandler = () => {
    setPurchased(false);
    setAddCommentModal(false);
  };

  const CommentModalHandler = async (orderId, suplierId) => {
    setAddCommentModal(true);
    setCommentSuplierId(suplierId);
    setCommentOrderId(orderId);
  };

  function calculateOrderTotals(data) {
    if (!data.orders || !Array.isArray(data.orders)) {
      return data;
    }
    data.orders.forEach((order) => {
      let total = 0;
      order.suppliers.forEach((supplier) => {
        let sup_total = 0;
        supplier.products.forEach((product) => {
          const productTotal =
            parseFloat(product.price) * parseInt(product.count);
          sup_total += productTotal;
        });
        supplier.total = sup_total;
        total += sup_total;
      });
      //total += order.delivery_price;
      order.total = parseInt(total);
    });
    return data;
  }
  let loading = null;

  if (data === undefined) {
    loading = <PointSpreadLoading color={"#ab0c59"} size={"small"} />;
  } else {
    loading =
      data.length === 0 ? (
        <div className={Style.NotOrderFoundHolder}>
          <div className={Style.ImageBasket}>
            <img src="/Assets/Images/Order/not2.png" alt="barest" />
          </div>
          <p className={Style.NoOrderText}>سفارشی یافت نشد</p>
        </div>
      ) : (
        data.map((item, index) => {
          let sum = 0;
          return (
            <section key={index} className={Style.RestaurantInfoHolder}>
              <section className={Style.baseInfoHolder}>
                <div>
                  <p>{`شماره سفارش: ${item.id}`}</p>
                </div>
                <div>
                  <p style={{ direction: "ltr" }}>
                    {" "}
                    {moment
                      .unix(parseInt(item.date))
                      .format("jYYYY/jM/jD--hh:mm")}
                  </p>
                </div>
              </section>
              {item.suppliers.map((value, count) => {
                sum = parseInt(value.total_price) + sum;
                return (
                  <div
                    key={count}
                    className={Style.RestaurantInfoHolder__TopPart}
                  >
                    <div className={Style.picAndText}>
                      <div className={Style.ImageHolder}>
                        <img
                          src={`//cdn.barest.ir/supplier/logo/${value.logo}.jpg`}
                          alt="رستوران"
                        />
                      </div>
                      <div className={Style.TextHolder}>
                        <h3 className={Style.supplierName}>
                          <FontAwesomeIcon
                            icon={faStore}
                            className={"storeIcon"}
                          />
                          {value.name}
                        </h3>
                        <div className={Style.StoreRate}>
                          <Rate
                            allowHalf
                            defaultValue={value.supplier_rate}
                            disabled
                          />
                        </div>
                        <div className={Style.AddressHolder}>
                          <p className={Style.address}>
                            <FontAwesomeIcon
                              className={Style.markerIcon}
                              icon={faMapMarkerAlt}
                            />
                            {value.address}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={Style.supplierPrice}>
                      <div className={Style.btnHolder}>
                        <Link
                          to={`supplier/${value.supplier_id}/`}
                          className={Style.buyBtn}
                        >
                          خرید در این فروشگاه
                        </Link>
                      </div>
                      {value.comment === 0 && value.type === "food" ? (
                        <div className={Style.btnHolder}>
                          <button
                            onClick={() =>
                              CommentModalHandler(item.id, value.supplier_id)
                            }
                            className={Style.commentBtn}
                          >
                            ثبت نظر
                          </button>
                        </div>
                      ) : null}
                      <span className={Style.totalPrice}>
                        {separate(value.total)}تومان
                      </span>
                    </div>
                    <button
                      className={Style.ProductListButton}
                      onClick={() => {
                        setModalState(true);
                        setOrderDataState(value.products);
                      }}
                    >
                      لیست اقلام سفارش داده شده
                    </button>
                  </div>
                );
              })}
              <div className={Style.bottomPart}>
                <div className={Style.PriceHolder}>
                  <h4>هزینه پیک</h4>
                  <span style={{ color: "green" }}>
                    {separate(parseInt(item.delivery_price))}
                    <span>تومان</span>
                  </span>
                </div>
              </div>
              <div className={Style.bottomPart}>
                <div className={Style.PriceHolder}>
                  <h4>قیمت نهایی</h4>
                  <span style={{ color: "green" }}>
                    {separate(
                      item?.total +
                        parseInt(item.delivery_price) -
                        parseInt(item.discount_amount)
                    )}
                    <span>تومان</span>
                  </span>
                </div>
              </div>
              {item.deliver.length !== 0 ? (
                <div className={Style.bottomPart}>
                  <div className={Style.PriceHolder}>
                    <h4>اطلاعات پیک:</h4>
                    <span>{`${item.deliver?.first_name} ${item.deliver?.last_name}`}</span>
                  </div>
                </div>
              ) : null}
              {item.deliver.length !== 0 ? (
                <div className={Style.bottomPart}>
                  <div className={Style.PriceHolder}>
                    <h4>شماره تماس پیک:</h4>
                    <a
                      href={`tel:${item.deliver?.phone}`}
                    >{`${item.deliver?.phone}`}</a>
                  </div>
                </div>
              ) : null}
              <div className={Style.bottomPart}>
                <div className={Style.PriceHolder}>
                  <h4>تحویل گیرنده:</h4>
                  <span>{`${item.first_name} ${item.last_name}`}</span>
                </div>
              </div>
              <div className={Style.bottomPart}>
                <div className={Style.PriceHolder}>
                  <h4>آدرس سفارش:</h4>
                  <span>{item.address}</span>
                </div>
              </div>
              <div className={Style.bottomPart}>
                <div className={Style.PriceHolder}>
                  <h4 style={{ color: "black" }}>آدرس نوشته شده شما :</h4>
                  <a
                    href={`https://maps.apple.com/?q=${item.lon},${item.lat}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {`${item.city}، ${item.region}، ${item.street}، ${
                      item.alley
                    } ${item.apartment_name && "، " + item.apartment_name}${
                      item.apartment_number !== "0"
                        ? "، " + item.apartment_number
                        : ""
                    }`}
                  </a>
                </div>
              </div>
              <div className={Style.ButtonHolder}>
                <button
                  className={Style.TransactionAndFactorButton}
                  onClick={() => FactorHandler(item.id)}
                >
                  فاکتور
                </button>
                <button
                  className={Style.TransactionAndFactorButton}
                  onClick={() => {
                    setModalState2(true);
                    setTransactionDataState(item.transactions);
                  }}
                >
                  تراکنشات سفارش
                </button>
              </div>
            </section>
          );
        })
      );
  }

  return (
    <div>
      <Modal show={purchased} modalClose={closeModalHandler} translate={40}>
        {FactorData && (
          <Factor
            close={closeModalHandler}
            factor={purchased}
            data={FactorData}
          />
        )}
      </Modal>
      <Modal
        show={AddCommentModal}
        modalClose={closeModalHandler}
        translate={40}
      >
        <AddComment
          close={closeModalHandler}
          getPastOrders={getPastOrders}
          commentSupId={commentSuplierId}
          commentProId={commentOrderId}
        />
      </Modal>
      <AntdModal
        title="لیست محصولات"
        open={modalState}
        onCancel={() => setModalState(false)}
        destroyOnClose
        style={{ direction: "rtl" }}
        closeIcon={<></>}
        footer={
          <button
            className={Style.closeModalButton}
            onClick={() => setModalState(false)}
          >
            بستن
          </button>
        }
      >
        <OrderPerviewList data={orderDataState} />
      </AntdModal>
      <AntdModal
        title="لیست تراکنشات"
        open={modalState2}
        onCancel={() => setModalState2(false)}
        destroyOnClose
        style={{ direction: "rtl" }}
        closeIcon={<></>}
        footer={
          <Button
            className={Style.closeModalButton}
            onClick={() => setModalState(false)}
          >
            بستن
          </Button>
        }
      >
        <TransactionList data={transactionDataState} />
      </AntdModal>
      <div className={Style.fixPage}>
        <div className={Style.OrderHolder}>{loading}</div>
      </div>
    </div>
  );
};

export default PastOrders;
